(($bs) => {
  const CLASS_NAME = "has-child-dropdown-show";

  // Handles opening/closing the closest dropdown.
  $bs.Dropdown.prototype.toggle = ((_orginal) => {
    return function multiLevelDropdown() {
      document.querySelectorAll(`.${CLASS_NAME}`).forEach((e) => {
        e.classList.remove(CLASS_NAME);
      });
      let dd = this._element
        .closest(".dropdown")
        .parentNode.closest(".dropdown");
      for (; dd && dd !== document; dd = dd.parentNode.closest(".dropdown")) {
        dd.classList.add(CLASS_NAME);
      }
      return _orginal.call(this);
    };
  })($bs.Dropdown.prototype.toggle);

  // When bootstrap performs the 'hide' event, check to see if we
  // Have the CLASS_NAME, remove it, and then prevent additional
  // Event propagation.
  document.querySelectorAll(".dropdown").forEach((dd) => {
    dd.addEventListener("hide.bs.dropdown", function multiLevelDropdownHide(e) {
      if (this.classList.contains(CLASS_NAME)) {
        this.classList.remove(CLASS_NAME);
        e.preventDefault();
      }
      e.stopPropagation();
    });
  });

  document
    .querySelectorAll(
      ".main--menu .dropdown, .menu--utility-menu .dropdown, .menu--multilanguage-local-menu-lih .dropdown"
    )
    .forEach((dd) => {
      dd.addEventListener("click", (e) => {
        document.querySelectorAll(".dropdown-menu, .fas").forEach((dm) => {
          if (
            !dd.contains(dm) &&
            !dm.contains(e.target) &&
            !dm.isEqualNode(e.target) &&
            !dm.parentElement.contains(e.target)
          ) {
            dm.classList.remove("show");
          }
        });
        if (e.target.tagName === "SPAN") {
          e.stopPropagation();
        }
        if (e.target.classList.contains("fas")) {
          e.target.classList.toggle("show");
          e.target.classList.toggle("hide");
          e.stopPropagation();
          e.target.parentNode.childNodes.forEach((el) => {
            if (
              el.classList !== undefined &&
              el.classList.contains("dropdown-menu")
            ) {
              el.classList.toggle("show");
              el.classList.toggle("hide");
            }
          });
        }
      });
    });

  document.addEventListener("click", (e) => {
    if (e.target.classList.contains("fas")) {
      return;
    }

    document
      .querySelectorAll(
        ".main--menu .dropdown-menu, .main--menu .fas, .menu--multilanguage-local-menu-lih .dropdown-menu, .menu--multilanguage-local-menu-lih .fas"
      )
      .forEach((dm) => {
        dm.classList.remove("show");
        dm.classList.add("hide");
      });
  });
})(bootstrap);
